import dateFormat from 'dateformat'
export function yesterday(){
    const start = new Date().setDate(new Date().getDate() - 1);
    return dateFormat(start, 'yyyy-mm-dd HH:MM:ss');
}
export function current(){
    return dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss');
}
